
import * as XLSX from 'xlsx';
import { Category } from '@/types';
import { toast } from 'sonner';
import { processCategories } from './excel/rowProcessing';
import { ExportRow } from './excel/types';

export const exportToExcel = async (categories: Category[], exportName: string) => {
  console.log('Starting Excel export with categories:', categories);
  
  if (!categories || categories.length === 0) {
    console.error('No categories to export');
    toast.error('No categories to export');
    return Promise.reject('No categories to export');
  }
  
  return new Promise<void>((resolve, reject) => {
    try {
      // Create a deep copy of categories to avoid any reference issues
      const categoriesCopy = JSON.parse(JSON.stringify(categories));
      console.log('Processing categories copy:', categoriesCopy);
      
      const rows: ExportRow[] = processCategories(categoriesCopy);
      console.log('Processed rows for export:', rows);

      if (rows.length === 0) {
        console.warn('No mapping rules found in categories, export will be empty');
        toast.warning('No mapping rules found in categories');
      }

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(rows);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Categories');

      const now = new Date();
      const timestamp = now.toISOString().replace(/[:.]/g, '-');
      const fileName = `${exportName || 'BeeMap'} ${timestamp}.xlsx`;
      console.log('Writing file with name:', fileName);

      // Use requestAnimationFrame to ensure UI updates complete
      requestAnimationFrame(() => {
        try {
          XLSX.writeFile(workbook, fileName);
          console.log('Excel export completed successfully');
          toast.success('Excel export completed successfully');
          resolve();
        } catch (error) {
          console.error('Error writing Excel file:', error);
          toast.error('Failed to save Excel file');
          reject(error);
        }
      });

    } catch (error) {
      console.error('Error during Excel export:', error);
      toast.error('Error during Excel export');
      reject(error);
    }
  });
};
